module.exports = __webpack_public_path__ + "static/img/5b24919.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/1-2.png
// module id = 684
// module chunks = 2